import {
    FETCH_MAKER_LIST_SUCCESS,
    FETCH_MAKER_LIST_REQUEST,
    FETCH_MAKER_LIST_ERROR,
    SHOW_MAKER_LOADER,
    HIDE_MAKER_LOADER,
    GET_ACTIVE_MAKER_REPORT_REQUEST,
    GET_ACTIVE_MAKER_REPORT_SUCCESS,
    GET_ACTIVE_MAKER_REPORT_ERROR,
    GENERATE_MAKER_REPORT_REQUEST,
    GENERATE_MAKER_REPORT_SUCCESS,
    GENERATE_MAKER_REPORT_ERROR,
    DOWNLOAD_MAKER_REPORT_ERROR,
    DOWNLOAD_MAKER_REPORT_REQUEST,
    DOWNLOAD_MAKER_REPORT_SUCCESS,
    GET_STATIC_DATA_REQUEST_MAKER,
    GET_STATIC_DATA_SUCCESS_MAKER,
    GET_STATIC_DATA_ERROR_MAKER,
} from './maker.constants';

export const fetchMakerRequest = payload => ({
    type: FETCH_MAKER_LIST_REQUEST,
    payload,
});

export const fetchMakerSuccess = payload => ({
    type: FETCH_MAKER_LIST_SUCCESS,
    payload,
});

export const fetchMakerError = payload => ({
    type: FETCH_MAKER_LIST_ERROR,
    payload,
});

export const generateMakerReportRequest = payload => ({
    type: GENERATE_MAKER_REPORT_REQUEST,
    payload,
});

export const generateReportSuccess = payload => ({
    type: GENERATE_MAKER_REPORT_SUCCESS,
    payload,
});

export const generateReportError = payload => ({
    type: GENERATE_MAKER_REPORT_ERROR,
    payload,
});

export const downloadMakerReportRequest = payload => ({
    type: DOWNLOAD_MAKER_REPORT_REQUEST,
    payload,
});

export const downloadMakerReportSuccess = payload => ({
    type: DOWNLOAD_MAKER_REPORT_SUCCESS,
    payload,
});

export const downloadMakerReportError = payload => ({
    type: DOWNLOAD_MAKER_REPORT_ERROR,
    payload,
});

export const getActiveMakerReportRequest = payload => ({
    type: GET_ACTIVE_MAKER_REPORT_REQUEST,
    hideLoader: payload.hideLoader,
    payload,
});

export const getActiveMakerReportSuccess = payload => ({
    type: GET_ACTIVE_MAKER_REPORT_SUCCESS,
    payload,
});

export const getActiveMakerReportError = payload => ({
    type: GET_ACTIVE_MAKER_REPORT_ERROR,
    payload,
});

export const getStaticDataRequestMaker = payload => ({
    type: GET_STATIC_DATA_REQUEST_MAKER,
    payload,
});

export const getStaticDataSuccessMaker = payload => ({
    type: GET_STATIC_DATA_SUCCESS_MAKER,
    payload,
});

export const getStaticDataErrorMaker = payload => ({
    type: GET_STATIC_DATA_ERROR_MAKER,
    payload,
});

export const showLoader = () => ({ type: SHOW_MAKER_LOADER });

export const hideLoader = () => ({ type: HIDE_MAKER_LOADER });
